export default __webpack_public_path__ + "static/media/IBMPlexSans-ExtraLight-Latin1.b4ab4176.woff2";